import gql from 'graphql-tag';

const mutation = gql`
  mutation SendPasswordReset($params: SendPasswordResetParams!) {
    sendPasswordReset(params: $params)
  }
`;

export default mutation;
